import Swal from 'sweetalert2';

export default function showAlert(title, message, msgType, buttonText) {
    let alertData;
    if (buttonText) {
        alertData = {
            title: title,
            text: message,
            icon: msgType,
            confirmButtonText: buttonText,
            timer: 4000000,
            allowOutsideClick: false, // Prevent closing by clicking outside
        };
    } else {
        alertData = {
            title: title,
            text: message,
            icon: msgType,
            timer: 4000000,
            allowOutsideClick: false, // Prevent closing by clicking outside
        };
    }
    Swal.fire(alertData);
}

export const conformationAlert = async (message, alertTypeIcon, actionType) => {
    let flag = false;
    let confirmButtonText = actionType === 'delete' ? 'Yes! Delete' : 'Yes! Update';
    await Swal.fire({
        title: message,
        html: `<strong>Do you want to ${message} ?</strong>`,
        icon: alertTypeIcon,
        showCancelButton: true,
        cancelButtonText: 'No! Close',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        confirmButtonColor: actionType === 'delete' ? '#d33' : '#50cd89',
        allowOutsideClick: false, // Prevent closing by clicking outside
    }).then((result) => {
        if (result.isConfirmed) {
            flag = true;
        } else {
            flag = false;
        }
    });
    return flag;
};

export const logoutAlert = async (message, alertTypeIcon, actionType) => {
    let flag = false;
    let confirmButtonText = 'Yes! Logout';
    await Swal.fire({
        title: message,
        html: `<strong>Do you want to ${message}</strong>`,
        icon: alertTypeIcon,
        showCancelButton: true,
        cancelButtonText: 'No! Close',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        confirmButtonColor: actionType === 'delete' ? '#d33' : '#50cd89',
        allowOutsideClick: false, // Prevent closing by clicking outside
    }).then((result) => {
        if (result.isConfirmed) {
            flag = true;
        } else {
            flag = false;
        }
    });
    return flag;
};

export const messageAlert = async (message, alertTypeIcon) => {
    let flag = false;
    let confirmButtonText = 'Ok';
    await Swal.fire({
        title: message,
        icon: alertTypeIcon,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#50cd89',
        allowOutsideClick: false, // Prevent closing by clicking outside
    }).then((result) => {
        if (result.isConfirmed) {
            flag = true;
        } else {
            flag = false;
        }
    });
    return flag;
};
